export enum CandidateTabsModel {
  CANDIDATE_SUMMARY = 'CANDIDATE_SUMMARY',
  MATCHING_RESULT = 'MATCHING_RESULT',
}
